// Constants for mysid values used in task form
export const TASK_FORM_MYSID = {
  ALL_CONTACTS: 'task_form_all_contacts',
  DEAL_CONTACTS: 'task_form_deal_contacts',
  ORIGINATIONS_DEALS: 'task_form_originations_deals',
  /** Used to fetch a single deal by id when related deal is not in assignee's list. */
  RELATED_DEAL_LOOKUP: 'task_form_related_deal_lookup',
} as const;
